import { useState, useEffect } from 'react';

export default function useSelectedSuggestion(searchResultsData) {
  const [selectedSuggestion, setSelectedSuggestion] = useState(null);

  useEffect(() => {
    setSelectedSuggestion(searchResultsData.length ? searchResultsData[0] : null);
  }, [searchResultsData]);

  return { selectedSuggestion, setSelectedSuggestion };
}
